/* tws-product-page.js — TWS gallery overlays */
(function () {
  'use strict';

  function initGalleryOverlays() {
    var wrapper = document.querySelector('.tws-product');
    if (!wrapper) return;

    var badgeText = wrapper.getAttribute('data-badge-text') || 'מאומת על ידינו';
    var isRTL = document.documentElement.dir === 'rtl';

    var gallery = wrapper.querySelector('.product-gallery');
    if (!gallery) return;

    var imageList = gallery.querySelector('.product-gallery__image-list');
    if (!imageList) return;

    /* Make image-list a positioning context */
    imageList.style.position = 'relative';

    /* ── Verified badge (mobile) ── */
    if (!imageList.querySelector('.tws-gallery-badge')) {
      var badge = document.createElement('div');
      badge.className = 'tws-gallery-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>' +
        '<span>' + badgeText + '</span>';
      imageList.appendChild(badge);
    }

    /* ── Verified badge (desktop) ── */
    if (!imageList.querySelector('.tws-gallery-badge--desktop')) {
      var badgeDesktop = document.createElement('div');
      badgeDesktop.className = 'tws-gallery-badge tws-gallery-badge--desktop';
      badgeDesktop.setAttribute('aria-hidden', 'true');
      badgeDesktop.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>' +
        '<span>' + badgeText + '</span>';
      imageList.appendChild(badgeDesktop);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryOverlays);
  } else {
    initGalleryOverlays();
  }
})();
